import IndexPage from "../../TopLevel/IndexPage";

const keyName = `ZmuAccPage`;
export default class ZmuAccPage extends IndexPage {
}